import React from "react";
import { HiChevronRight } from "react-icons/hi";
import { Link } from "react-router-dom";
import { useGetResultsQuery } from "../../redux/slices/api/resultApiSlice";

import { Bars } from "react-loader-spinner";
import ResultImg from "../../assets/img/home/result-img.jpg";
import SpecialResultCard from "../results/SpecialResultCard";

const ResultDiscoverySection = () => {
  const { data: discoveryData, isLoading } = useGetResultsQuery();
  const { results } = discoveryData ?? {};
  return (
    <div className="w-full flex flex-col">
      {/* Section Header */}
      <div className="w-full flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-12">
        <div className="flex flex-col">
          <span className="text-primary-green roboto-font text-sm font-medium uppercase tracking-wider mb-3">
            Discover Results
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl abel-font text-white">
            Results Discovery
          </h2>
        </div>
        <Link
          to="/discovery"
          className="group flex items-center gap-2 px-6 py-3 rounded-xl bg-white/10 hover:bg-white/15 border border-white/20 backdrop-blur-sm transition-all duration-300"
        >
          <span className="text-white font-medium">See all results</span>
          <HiChevronRight
            className="text-white group-hover:translate-x-1 transition-transform duration-300"
            size={20}
          />
        </Link>
      </div>

      {isLoading ? (
        <div className="w-full min-h-[480px] flex justify-center items-center">
          <div className="flex flex-col items-center gap-4">
            <Bars
              height="50"
              width="50"
              color="#0EA4BD"
              ariaLabel="bars-loading"
              visible={true}
            />
            <span className="text-white/50 roboto-font">Loading results...</span>
          </div>
        </div>
      ) : results?.length > 0 ? (
        <div className="w-full flex flex-col justify-center items-center gap-6 mt-2">
          {/* Result Cards Grid */}
          <div className="w-full grid grid-cols-1 mlg:grid-cols-2 gap-5">
            {results?.slice(0, 6)?.map((item) => (
              <SpecialResultCard
                resultData={item}
                projectData={item?.project}
                key={item?._id}
              />
            ))}
          </div>
        </div>
      ) : (
        <div className="w-full min-h-[400px] flex flex-col justify-center items-center rounded-2xl border border-white/10 bg-gradient-to-br from-white/5 to-white/[0.02] backdrop-blur-sm p-12">
          <div className="w-20 h-20 rounded-full bg-gradient-to-br from-primary-green/20 to-primary/20 flex items-center justify-center mb-6">
            <svg className="w-10 h-10 text-primary-green/60" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <h3 className="text-2xl font-semibold text-white mb-2">No Results Yet</h3>
          <p className="text-white/50 text-center max-w-md mb-6">
            Research results will appear here once projects start publishing their findings.
          </p>
          <Link
            to="/projects"
            className="px-6 py-3 bg-gradient-to-r from-primary-green to-primary text-white rounded-xl font-medium hover:shadow-lg hover:shadow-primary-green/20 transition-all duration-300"
          >
            Explore Projects
          </Link>
        </div>
      )}
    </div>
  );
};

export default ResultDiscoverySection;
